<!-- Main content -->
<div style="height: 10px; width: 100%; background-color: #f8f9fa"></div>
<section class="content" style="display: block; background-color: #f8f9fa">
    <div class="container-fluid" *ngIf="this.allowPageRender">
        <div class="row" *ngIf="mode === 3 || mode === 2">
            <div class="col-12">
                <label>
                    {{
                        mode === 3
                            ? 'Organisation : ' + this.OrganizationName
                            : 'Role : ' + RoleName
                    }}
                </label>
            </div>
        </div>
        <!-- Small boxes (Stat box) -->
        <div class="row" style="margin-bottom: 24px">
            <div class="col-4">
                <mat-form-field
                    appearance="fill"
                    class="white-dropdown"
                    style="
                        width: 100%;
                        box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
                    "
                >
                    <mat-label>Select Camera</mat-label>
                    <mat-select
                        [(value)]="selectedCameraId"
                        (valueChange)="
                            this.selectedCameraIdOld = selectedCamera.id
                        "
                        (selectionChange)="onCameraChange($event)"
                    >
                        <mat-option
                            class="input-value"
                            *ngFor="let camera of cameraList"
                            [value]="camera.id"
                        >
                            {{ camera.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-6">
                <input
                    type="text"
                    class="form-control box-shadow mask"
                    style="height: 48px; border: none !important"
                    placeholder="Look for specific setting"
                    autocomplete="off"
                    (keyup)="updateSearchText($event)"
                    (keydown.enter)="$event.preventDefault()"
                    [value]="searchText"
                />
            </div>

            <div class="col-2">
                <button
                    class="btn default-success rounded-pill"
                    style="
                        width: 100%;
                        font-size: 16px;
                        font-weight: 500;
                        height: 48px;
                    "
                    type="button"
                    (click)="onSubmit()"
                >
                    Apply changes
                </button>
            </div>
        </div>
        <div class="row" [formGroup]="this.form">
            <div class="col-4">
                <mat-card  style="height: 100%">
                    <mat-card-header>
                        <mat-card-title
                            class="heading-color"
                            style="font-size: 24px"
                            >{{ selectedCamera.name }} Setting
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <mat-selection-list [multiple]="false">
                            <mat-list-option
                                [selected]="this.selectedTabId == tab.id"
                                *ngFor="let tab of tabs"
                                [value]="tab"
                                (click)="onTabChange(tab)"
                            >
                                <div class="with-icon">
                                    <fa-icon
                                        [icon]="tab.icon"
                                        style="height: 16px; width: 16px"
                                    ></fa-icon>
                                    <span
                                        style="
                                            margin-left: 16px;
                                            margin-top: 5px;
                                            font-size: 16px;
                                            font-weight: 500;
                                            letter-spacing: -0.38px;
                                            line-height: 40px;
                                        "
                                        class="heading-color"
                                        >{{ tab.title }}</span
                                    >
                                </div>
                            </mat-list-option>
                        </mat-selection-list>
                    </mat-card-content>
                </mat-card>
            </div>

            <div
                class="col-8 scrollable-div"
                style="height: 80vh; overflow-y: auto"
                #scrollableDiv
                (scroll)="onScroll($event)"
            >
                <button
                    #scrollToTopButton
                    class="scroll-to-top"
                    type="button"
                    (click)="scrollToTop()"
                    style="
                        display: none;
                        position: fixed;
                        right: 2%;
                        z-index: 99;
                        bottom: 5%;
                        width: 45px;
                        height: 45px;
                        color: white;
                        border: 1px solid #142430;
                        border-radius: 50%;
                        background: #142430;
                    "
                >
                    <fa-icon
                        [icon]="faChevronUp"
                        style="font-size: 10px"
                    ></fa-icon>
                </button>
                <div *ngFor="let item of CameraSettings">
                    <div
                        style="height: 100%"
                        [id]="item.tab.title + '_' + item.tab.id"
                    >
                        <div class="tab-title">
                            <fa-icon [icon]="item.tab.icon"></fa-icon>
                            <span>{{ item.tab.title }}</span>
                        </div>

                        <mat-accordion class="example-headers-align" multi>
                            <ng-container *ngFor="let group of item.groups">
                                <mat-expansion-panel
                                    *ngIf="
                                        group.initialValues &&
                                        group.initialValues.length > 0 &&
                                        PropertyNameDisplayCheckGroup(
                                            group.initialValues
                                        )
                                    "
                                    [(expanded)]="group.isOpen"
                                    (opened)="group.isOpen = true"
                                    (closed)="group.isOpen = false"
                                >
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <span
                                                style="
                                                    display: flex;
                                                    justify-content: center;
                                                    align-items: center;
                                                "
                                            >
                                                <fa-icon
                                                    [icon]="faChevronUp"
                                                    *ngIf="group.isOpen"
                                                    style="font-size: 10px"
                                                ></fa-icon>
                                                <fa-icon
                                                    [icon]="faChevronDown"
                                                    *ngIf="!group.isOpen"
                                                    style="font-size: 10px"
                                                ></fa-icon>
                                            </span>
                                            {{ group.group.title }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="row">
                                        <ng-container
                                            *ngFor="
                                                let property of group.initialValues
                                            "
                                        >
                                            <div
                                                *ngIf="
                                                    PropertyNameDisplayCheck(
                                                        property.displayName
                                                    )
                                                "
                                                [class]="'col-' + property.size"
                                            >
                                                <mat-generic-form-field
                                                    [property]="property"
                                                    [form]="this.form"
                                                    style="margin-bottom: 2%"
                                                    (onChange)="
                                                        updateValues({
                                                            name: property.propertyName,
                                                            value: $event
                                                        })
                                                    "
                                                >
                                                </mat-generic-form-field>
                                            </div>
                                        </ng-container>
                                    </div>
                                </mat-expansion-panel>
                            </ng-container>
                        </mat-accordion>
                        <br />
                    </div>
                </div>
            </div>
        </div>
        <!-- /.row -->
    </div>
    <!-- Main row -->
</section>
<div style="height: 25px; width: 100%; background-color: #f8f9fa"></div>
<!-- /.content -->
